import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../utils/network/generated/protoTypes";
import { actionPlayerInfoChangeName } from "../info/player/actionPlayerInfo";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { TypeActionSetPlayerName } from "./actionSetPlayerName";
export var epicSetPlayerName = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionSetPlayerName.ChangePlayerName), switchMap(function (action) {
        var state = state$.value;
        return deps
            .netSend({
            id: CommandCode.ChoosePlayerName,
            props: {
                newPlayerName: action.username,
                playerId: state.playerInfo.playerId,
            },
        })
            .pipe(switchMap(function (res) {
            return from([
                actionModalClose(IdModal.SetPlayerName),
                actionPlayerInfoChangeName(res.newPlayerName),
            ]);
        }), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/set-player-name/epicSetPlayerName.ts
// module id = 2331
// module chunks = 3